import React, { useState } from "react";
import { motion } from "framer-motion";
import { useCart } from "./CartContext";

const ACService = () => {
  const { addToCart } = useCart();
  const [openDetail, setOpenDetail] = useState("");
  const [openFaq, setOpenFaq] = useState(null);

  const toggleDetails = (service) => {
    setOpenDetail(openDetail === service ? "" : service);
  };

  const services = [
    {
      title: "Jet AC service - 1 AC",
      price: 500,
      time: "30 mins",
      image: "/images/1ac.jpg",
      issues: [
        "Valid for both split and window AC units",
        "Indoor unit deep cleaning with jet spray",
      ],
    },
    {
      title: "Jet AC service - 2 ACs",
      price: 900,
      time: "60 mins",
      image: "/images/1ac.jpg",
      issues: [
        "Valid for both split and window AC units",
        "Indoor unit deep cleaning with jet spray",
      ],
    },
    {
      title: "Jet AC service - 3 ACs",
      price: 1350,
      time: "60 mins",
      image: "/images/1ac.jpg",
      issues: [
         "Valid for both split and window AC units",
        "Jet cleaning of indoor unit",
        "Outdoor unit cleaned using high-pressure jet spray",
      ],
    },
    {
      title: "Jet AC service - 4 ACs",
      price: 1800,
      time: "60 mins",
      image: "/images/1ac.jpg",
      issues: [
        "Valid for both split and window AC units",
        "Jet cleaning of indoor unit",
        "Outdoor unit cleaned using high-pressure jet spray",
      ],
    },
    {
      title: "Jet AC  service - 5 ACs",
      price: 2250,
      time: "2 hrs",
      image: "/images/1ac.jpg",
      issues: [
        "Valid for both split and window AC units",
        "Jet cleaning of indoor unit",
        "Outdoor unit cleaned using high-pressure jet spray",
      ],
    },
  ];

  const faqs = [
    {
      question: "Do spare parts come with warranty?",
    answer:
      "Yes, parts provided by us are covered under warranty. However, if you arrange the parts, we won’t be able to provide any warranty on them.",
  },
  {
    question: "What happens if the same issue comes back?",
    answer:
      "We provide a warranty on our repair services. If the same problem occurs again within that period, we’ll fix it free of cost.",
  },
  {
    question: "Do you service centralized or VRV air conditioners?",
    answer:
      "We handle household ACs like split and window units. At the moment, we don’t service centralized or VRV AC systems.",
  },
  {
    question: "How can I be sure the quote is genuine?",
    answer:
      "All pricing is reviewed by our team before it reaches you. Still have doubts? Feel free to speak to an expert through the app.",
  },
  {
    question: "What if I’m being asked to pay extra?",
    answer:
      "Technicians are required to follow our fixed pricing. If you feel overcharged, reach out to us immediately through the help center.",
  },
  {
    question: "Will the technician check the AC post service?",
    answer:
      "Yes, the technician will run checks before and after servicing — including gas leak inspection, pressure test, and cooling performance.",
  },
  {
    question: "Will the technician bring all tools needed?",
    answer:
      "Yes, they’ll come equipped with necessary tools. Just note that they don’t carry a ladder, so please arrange one if your AC is installed high.",
  },
  {
    question: "What if the technician finds a problem during the service?",
    answer:
      "If any fault is found, you’ll be given a repair estimate based on our rate card. You can decide whether or not to proceed with it.",
  }
];

  return (
 <div style={{ padding: 10, maxWidth: 800, margin: "auto" }}>
  <h1 className="text-2xl font-bold mb-6">AC Services & Cleaning</h1>

  {services.map((service, index) => (
   <div
  key={index}
  className="service-card"
  style={{
    border: "1px solid #ccc",
    borderRadius: 10,
    padding: 20,
    marginBottom: 20,
    backgroundColor: "#f9f9f9",
  }}
>
  <div
  className="service-card"
  style={{
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap", // mobile pe overflow avoid
  }}
>
  {/* Left side: stacked content */}
  <div style={{ flex: 1, minWidth: "150px" }}>
    <h2 style={{ fontSize: 18, fontWeight: "bold" }}>{service.title}</h2>
    <p style={{ color: "#555" }}>₹{service.price} - {service.time}</p>

    <div style={{ marginTop: 10, display: "flex", gap: 10 }}>
      <button
        onClick={() => toggleDetails(service.title)}
        style={{
          padding: "6px 12px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: 5,
          cursor: "pointer",
        }}
      >
        View Details
      </button>
      <button
        onClick={() => addToCart({ ...service, name: service.title })}
        style={{
          padding: "6px 12px",
          backgroundColor: "#28a745",
          color: "white",
          border: "none",
          borderRadius: 5,
          cursor: "pointer",
        }}
      >
        Add
      </button>
    </div>
  </div>

  {/* Right side: image */}
  <img
    src={service.image}
    alt={service.title}
    className="service-image"
    style={{
      width: 120, // default mobile size
      height: 120,
      objectFit: "cover",
      borderRadius: 10,
    }}
  />
</div>

  {/* Details section */}
   {openDetail === service.title && (
    <motion.div
      className="details-box"
      initial={{ y: 30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
      style={{
        marginTop: 15,
        backgroundColor: "#eef2f7",
        borderRadius: 8,
        padding: 15,
      }}
    >
      <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>{service.title}</h3>
      <p style={{ marginBottom: 10 }}>₹{service.price} - {service.time}</p>
      <h4 style={{ fontWeight: "bold" }}>About the service:</h4>
      <ul style={{ paddingLeft: 20 }}>
        {service.issues.map((issue, i) => (
          <li key={i} style={{ fontSize: 14 }}>{issue}</li>
        ))}
      </ul>
      <h4 style={{ fontWeight: "bold", marginTop: 10 }}>Top technicians:</h4>
      <ul style={{ paddingLeft: 20, fontSize: 14 }}>
        <li>Background verified</li>
        <li>Trained across all major brands</li>
      </ul>
      <p style={{ fontSize: 13, marginTop: 5 }}>We Service All Brands</p>
    </motion.div>
  )}
</div>

    ))}

    {/* Updated FAQ section */}
    <div style={{ marginTop: 40 }}>
      <h2 className="text-2xl font-bold mb-4">Frequently Asked Questions</h2>
      {faqs.map((faq, index) => (
        <div
          key={index}
          style={{
            border: "1px solid #ccc",
            borderRadius: 10,
            padding: 20,
            marginBottom: 20,
            backgroundColor: "#f9f9f9",
          }}
        >
          <button
            onClick={() => setOpenFaq(openFaq === index ? null : index)}
            style={{
              width: "100%",
              textAlign: "left",
              background: "none",
              border: "none",
              fontWeight: "bold",
              color: "#007bff",
              cursor: "pointer",
              fontSize: 16,
            }}
          >
            {faq.question}
          </button>
          {openFaq === index && (
            <p style={{ marginTop: 10, fontSize: 16, color: "Black" }}>
              {faq.answer}
            </p>
          )}
        </div>
      ))}
      <div style={{ height: "400px" }}></div>
    </div>
  </div>
);

};

export default ACService;
